<app-container class="flex container" ngClass.xs="xs" [maxWidth]="handsetService.isXs ? '100%' : '552px'"
               [noPadding]="handsetService.isMobile">
  <app-card [sidePaddings]="'60px'" [mobileSidePaddings]="'15px'">
    <div content>
      <div class="text-center" style="margin-bottom: 30px;">
        <img alt="prace-serwisowe" [height]="125"
             src="/assets/images/maintenance/praceSerwisowe.svg" (load)="onImageLoad()" />
      </div>

      <div *ngIf="imageLoaded">
        <h1 class="header text-center"
            style="font-size: 14px; font-weight: bold; margin: 40px  0">
          Trwają zaplanowane prace rozwojowe</h1>


        <p class="text-center" style="padding-bottom: 25px">
          Dbamy o to, aby Panel Payka działał jeszcze sprawniej! Aktualnie prowadzimy prace techniczne, dlatego dostęp
          do Panelu jest tymczasowo ograniczony.
        </p>

        <p *ngIf="details" class="text-center bold" style="padding-bottom: 25px">
          {{ details }}
        </p>


        <p class="text-center" style="padding-bottom: 40px">
          Dziękujemy za cierpliwość! Jeśli masz pilne pytania, skontaktuj się z naszym wsparciem:
        </p>

        <div class="flex flex-col primary-action-container">
          <button
            mat-raised-button
            color="accent"
            class="primary-action big-button button-250"
            style="height: 48px; border-radius: 24px;"
            fxFlexAlign="center"
            (click)="openContactInNewTab()">
            <span>Kontakt</span>
          </button>
        </div>

      </div>
    </div>


  </app-card>
</app-container>

